import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// ── HEADER ─────────────────────────────────────────
const addHeader = (doc, title, subtitle = '') => {
  // Header background
  doc.setFillColor(30, 58, 138);
  doc.rect(0, 0, 210, 35, 'F');

  // Organization name
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('BBSHRRDB', 14, 12);

  // Full name
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('Benazir Bhutto Shaheed Human Resource Research & Development Board', 14, 18);
  doc.text('Universities & Boards Department — Government of Sindh', 14, 23);

  // Report title
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text(title, 14, 30);

  if (subtitle) {
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text(subtitle, 14, 35);
  }

  // Date on right
  doc.setFontSize(8);
  doc.setTextColor(191, 219, 254);
  doc.text(`Generated: ${new Date().toLocaleString('en-PK')}`, 196, 12, { align: 'right' });
  doc.text('FMAS v1.0 — Confidential', 196, 17, { align: 'right' });

  // Reset color
  doc.setTextColor(0, 0, 0);

  return 45; // Return Y position after header
};

// ── FOOTER ─────────────────────────────────────────
const addFooter = (doc) => {
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFillColor(243, 244, 246);
    doc.rect(0, 285, 210, 12, 'F');
    doc.setFontSize(8);
    doc.setTextColor(107, 114, 128);
    doc.text('FMAS — Field Monitoring & Attendance System — BBSHRRDB', 14, 291);
    doc.text(`Page ${i} of ${pageCount}`, 196, 291, { align: 'right' });
  }
};

// ── EXPORT PMR REPORT ──────────────────────────────
export const exportPMRReport = (report, sections) => {
  const doc = new jsPDF();
  let y = addHeader(doc, 'Program Monitoring Report (PMR)', `Book No: ${report.book_no || '—'} | PMR No: ${report.pmr_no || '—'} | Wing: ${report.wing || '—'}`);

  y += 5;

  // Report Info Box
  doc.setFillColor(239, 246, 255);
  doc.rect(14, y, 182, 28, 'F');
  doc.setDrawColor(191, 219, 254);
  doc.rect(14, y, 182, 28, 'D');

  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(30, 58, 138);

  // Left column
  doc.text('Institution:', 18, y + 7);
  doc.text('District:', 18, y + 13);
  doc.text('Sector:', 18, y + 19);
  doc.text('Officer:', 18, y + 25);

  // Left values
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text(report.institution_name || '—', 45, y + 7);
  doc.text(report.district_name || '—', 45, y + 13);
  doc.text(report.training_sector || '—', 45, y + 19);
  doc.text(report.officer_name || '—', 45, y + 25);

  // Right column
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(30, 58, 138);
  doc.text('Visit Date:', 115, y + 7);
  doc.text('Start Time:', 115, y + 13);
  doc.text('End Time:', 115, y + 19);
  doc.text('Training Month:', 115, y + 25);

  // Right values
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text(report.visit_date ? new Date(report.visit_date).toLocaleDateString('en-PK') : '—', 148, y + 7);
  doc.text(report.start_time ? new Date(report.start_time).toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit', hour12: true }) : '—', 148, y + 13);
  doc.text(report.end_time ? new Date(report.end_time).toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit', hour12: true }) : '—', 148, y + 19);
  doc.text(String(report.training_month_number || '—'), 148, y + 25);

  y += 35;

  // Section 1 — Profile
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setFillColor(30, 58, 138);
  doc.setTextColor(255, 255, 255);
  doc.rect(14, y, 182, 7, 'F');
  doc.text('1. Profile of Institute', 16, y + 5);
  doc.setTextColor(0, 0, 0);
  y += 10;

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(`Visits This Month: ${report.visits_this_month || 0}`, 18, y);
  doc.text(`Total Visits So Far: ${report.total_visits_so_far || 0}`, 80, y);
  y += 8;

  // Section 2 — Attendance
  if (sections?.attendance?.length > 0) {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setFillColor(30, 58, 138);
    doc.setTextColor(255, 255, 255);
    doc.rect(14, y, 182, 7, 'F');
    doc.text('2. Attendance & Stipend', 16, y + 5);
    doc.setTextColor(0, 0, 0);
    y += 10;

    autoTable(doc, {
      startY: y,
      head: [['Trade', 'Tutors Present', 'Present (Date)', 'Present (Visit)', 'Absent', 'Stipend', 'ID Cards']],
      body: sections.attendance.map(row => [
        row.course_name,
        row.tutors_present || 0,
        row.trainees_present_on_date || 0,
        row.trainees_present_current_visit || 0,
        row.trainees_absent || 0,
        row.trainees_received_stipend || 0,
        row.trainees_displaying_id || 0,
      ]),
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [59, 130, 246], textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [239, 246, 255] },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 8;
  }

  // Section 3 — Academic Progress
  if (sections?.academic?.length > 0) {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setFillColor(30, 58, 138);
    doc.setTextColor(255, 255, 255);
    doc.rect(14, y, 182, 7, 'F');
    doc.text('3. Academic Progress', 16, y + 5);
    doc.setTextColor(0, 0, 0);
    y += 10;

    autoTable(doc, {
      startY: y,
      head: [['Trade', 'Weeks', 'Current Topic', 'Completed %', 'Remaining %', 'Activity Plan', 'Manual']],
      body: sections.academic.map(row => [
        row.course_name,
        row.weeks_completed || 0,
        row.current_topic || '—',
        `${row.progress_completed_percent || 0}%`,
        `${row.progress_remaining_percent || 0}%`,
        row.activity_plan_available ? 'Yes' : 'No',
        row.training_manual_available ? 'Yes' : 'No',
      ]),
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [59, 130, 246], textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [239, 246, 255] },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 8;
  }

  // Section 4 — Examination
  if (sections?.examination?.length > 0) {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setFillColor(30, 58, 138);
    doc.setTextColor(255, 255, 255);
    doc.rect(14, y, 182, 7, 'F');
    doc.text('4. Test / Examination', 16, y + 5);
    doc.setTextColor(0, 0, 0);
    y += 10;

    autoTable(doc, {
      startY: y,
      head: [['Trade', 'Tests Planned', 'Conducted', 'Appeared', 'Passed', 'Pass Rate', 'Comments']],
      body: sections.examination.map(row => [
        row.course_name,
        row.tests_planned || 0,
        row.tests_conducted || 0,
        row.trainees_appeared || 0,
        row.trainees_passed || 0,
        row.trainees_appeared > 0
          ? `${Math.round((row.trainees_passed / row.trainees_appeared) * 100)}%`
          : '—',
        row.comments || '—',
      ]),
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [59, 130, 246], textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [239, 246, 255] },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 8;
  }

  // Section 5 — Facilities
  if (sections?.facilities?.length > 0) {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setFillColor(30, 58, 138);
    doc.setTextColor(255, 255, 255);
    doc.rect(14, y, 182, 7, 'F');
    doc.text('5. Facilities Gradation', 16, y + 5);
    doc.setTextColor(0, 0, 0);
    y += 10;

    autoTable(doc, {
      startY: y,
      head: [['Trade', 'Tutor', 'Manual', 'Equipment', 'Climate', 'Facilities', 'Total/25']],
      body: sections.facilities.map(row => [
        row.course_name,
        row.tutor_capacity_score || 0,
        row.training_manual_score || 0,
        row.training_material_score || 0,
        row.learning_climate_score || 0,
        row.facilities_score || 0,
        row.grand_total || 0,
      ]),
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [59, 130, 246], textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [239, 246, 255] },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 8;
  }

  // Section 6 — Concluding Comments
  if (report.overall_assessment) {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setFillColor(30, 58, 138);
    doc.setTextColor(255, 255, 255);
    doc.rect(14, y, 182, 7, 'F');
    doc.text('6. Concluding Comments', 16, y + 5);
    doc.setTextColor(0, 0, 0);
    y += 10;

    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    const lines = doc.splitTextToSize(report.overall_assessment, 178);
    doc.text(lines, 14, y);
    y += lines.length * 5 + 5;
  }

  // Signatures
  if (y > 240) {
    doc.addPage();
    y = 20;
  }

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setFillColor(30, 58, 138);
  doc.setTextColor(255, 255, 255);
  doc.rect(14, y, 182, 7, 'F');
  doc.text('Signatures', 16, y + 5);
  doc.setTextColor(0, 0, 0);
  y += 15;

  // Signature boxes
  doc.setDrawColor(200, 200, 200);
  doc.rect(14, y, 85, 25);
  doc.rect(111, y, 85, 25);

  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(107, 114, 128);
  doc.text('Focal Person / Principal Signature', 56, y + 22, { align: 'center' });
  doc.text('Monitoring Officer Signature', 153, y + 22, { align: 'center' });

  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);
  doc.text(report.officer_name || '—', 153, y + 10, { align: 'center' });

  addFooter(doc);
  doc.save(`PMR_${report.pmr_no || 'Report'}_${report.institution_name || ''}.pdf`);
};

// ── EXPORT ATTENDANCE REPORT ───────────────────────
export const exportAttendanceReport = (attendance, dateRange = '') => {
  const doc = new jsPDF();
  addHeader(doc, 'Attendance Report', dateRange);

  const present = attendance.filter(a => a.status === 'Present').length;
  const late = attendance.filter(a => a.status === 'Late').length;
  const halfDay = attendance.filter(a => a.status === 'Half Day').length;
  const absent = attendance.filter(a => a.status === 'Absent').length;

  // Summary boxes
  let y = 50;
  const boxes = [
    { label: 'Present', value: present, color: [34, 197, 94] },
    { label: 'Late', value: late, color: [245, 158, 11] },
    { label: 'Half Day', value: halfDay, color: [249, 115, 22] },
    { label: 'Absent', value: absent, color: [239, 68, 68] },
  ];

  boxes.forEach((box, i) => {
    const x = 14 + i * 46;
    doc.setFillColor(...box.color);
    doc.rect(x, y, 42, 18, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(String(box.value), x + 21, y + 10, { align: 'center' });
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(box.label, x + 21, y + 16, { align: 'center' });
  });

  doc.setTextColor(0, 0, 0);
  y += 25;

  autoTable(doc, {
    startY: y,
    head: [['#', 'Officer Name', 'Role', 'District', 'Date', 'Entry', 'Exit', 'Duration', 'Late By', 'Status']],
    body: attendance.map((record, index) => [
      index + 1,
      record.full_name,
      record.role,
      record.district_name || '—',
      record.date ? new Date(record.date).toLocaleDateString('en-PK') : '—',
      record.first_entry_time ? new Date(record.first_entry_time).toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit', hour12: true }) : '—',
      record.last_exit_time ? new Date(record.last_exit_time).toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit', hour12: true }) : '—',
      record.total_duration_minutes > 0
        ? `${Math.floor(record.total_duration_minutes / 60)}h ${record.total_duration_minutes % 60}m`
        : '—',
      record.late_duration_minutes > 0 ? `${record.late_duration_minutes}m` : '—',
      record.status,
    ]),
    styles: { fontSize: 7, cellPadding: 2 },
    headStyles: { fillColor: [30, 58, 138], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [239, 246, 255] },
    didDrawCell: (data) => {
      if (data.section === 'body' && data.column.index === 9) {
        const status = data.cell.raw;
        const colors = {
          'Present': [34, 197, 94],
          'Late': [245, 158, 11],
          'Half Day': [249, 115, 22],
          'Absent': [239, 68, 68],
        };
        if (colors[status]) {
          doc.setTextColor(...colors[status]);
          doc.setFont('helvetica', 'bold');
          doc.text(status, data.cell.x + data.cell.width / 2,
            data.cell.y + data.cell.height / 2 + 1, { align: 'center' });
          doc.setTextColor(0, 0, 0);
          doc.setFont('helvetica', 'normal');
        }
      }
    },
    margin: { left: 14, right: 14 },
  });

  addFooter(doc);
  doc.save(`Attendance_Report_${new Date().toLocaleDateString('en-PK').replace(/\//g, '-')}.pdf`);
};

// ── EXPORT USERS REPORT ────────────────────────────
export const exportUsersReport = (users) => {
  const doc = new jsPDF();
  addHeader(doc, 'Users Report', `Total Users: ${users.length}`);

  autoTable(doc, {
    startY: 50,
    head: [['#', 'Full Name', 'Email', 'Phone', 'CNIC', 'Employee ID', 'Role', 'District', 'Status']],
    body: users.map((user, index) => [
      index + 1,
      user.full_name,
      user.email,
      user.phone_number,
      user.cnic || '—',
      user.employee_id || '—',
      user.role,
      user.district_name || '—',
      user.is_active ? 'Active' : 'Inactive',
    ]),
    styles: { fontSize: 7, cellPadding: 2 },
    headStyles: { fillColor: [30, 58, 138], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [239, 246, 255] },
    margin: { left: 14, right: 14 },
  });

  addFooter(doc);
  doc.save(`Users_Report_${new Date().toLocaleDateString('en-PK').replace(/\//g, '-')}.pdf`);
};